import { Roles } from '@/scripts/consts'

export const links = [
  {
    id: 1,
    icon: 'user',
    text: 'Сотрудник',
    route: '/employee',
    allowRoles: [
      Roles.Admin,
      Roles.Moderator,
      Roles.Employee,
      Roles.ViewEfficiencyMetrics,
      Roles.ViewScientificWork,
      Roles.Auditor
    ]
  },
  {
    id: 2,
    icon: 'book-open',
    text: 'Научные работы',
    route: '/works',
    allowRoles: [
      Roles.Admin,
      Roles.Moderator,
      Roles.ModeratorNir,
      Roles.ModeratorDiss,
      Roles.ModeratorGrantContest,
      Roles.ModeratorScientificEvent,
      Roles.Employee
    ]
  },
  {
    id: 3,
    icon: 'text-box-multiple-outline',
    text: 'Участие в работе редакционных коллегий журналов',
    route: '/journal-editorail-boards',
    allowRoles: [Roles.Admin, Roles.Moderator, Roles.Employee]
  },
  {
    id: 4,
    icon: 'trending-up',
    text: 'Показатели результативности научной деятельности',
    route: '/efficiency',
    allowRoles: [Roles.Admin, Roles.ViewEfficiencyMetrics, Roles.Auditor]
  },
  {
    id: 5,
    icon: 'file-text',
    text: 'Публикации преподавателей',
    route: '/publications',
    allowRoles: [Roles.Admin, Roles.ViewScientificWork, Roles.Auditor]
  },
  {
    id: 6,
    icon: 'sliders',
    text: 'Справочники',
    route: '/directories',
    allowRoles: [
      Roles.Admin,
      Roles.Moderator,
      Roles.ModeratorNir,
      Roles.ModeratorDiss,
      Roles.ModeratorGrantContest,
      Roles.ModeratorScientificEvent
    ],
    linksSwitcher: false
  },

  {
    id: 7,
    icon: 'table-account',
    text: 'Справочник сотрудников',
    route: '/employee-directory',
    allowRoles: [Roles.Admin, Roles.DepartManager],
    linksSwitcher: false
  }
]

export const OppositionAllowRoles = [Roles.Admin, Roles.ViewScientificWork]
